import { defineSlotRecipe } from "@chakra-ui/react";
import { toastAnatomy } from "@chakra-ui/react/anatomy";

// Chakra v2 `solid` toasts: every status on its solid colour, 16px text.
const toastRecipe = defineSlotRecipe({
  slots: toastAnatomy.keys(),
  base: {
    root: {
      "&[data-type=info]": {
        bg: "blue.solid",
        color: "blue.contrast",
        "--toast-trigger-bg": "{white/10}",
        "--toast-border-color": "{white/40}",
      },
    },
    title: {
      fontWeight: "bold",
      textStyle: "md",
    },
    description: {
      textStyle: "md",
      opacity: 1,
    },
  },
});

export default toastRecipe;
